import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class LogbookAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/logbook";
    return this.CommonAPIService.getCall(url, null, router);
  }

  getById(id, router) {
    const url = `/api/logbook/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getByUserId(userId, router) {
    const url = `/api/logbook/user/${userId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(params, router) {
    const url = "/api/logbook";
    return this.CommonAPIService.postCall(url, params, router);
  }

  update(userId, params, router) {
    const url = `/api/logbook/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default LogbookAPIService;
